import { useShowResponseStatus } from '@/shared';
import { useCreateWhitelistMutation } from '../store/whitelist-api';
import { handleWhitelistCreateError } from '../utils/helpers/whitelist-errors';

import type { TWhitelistCreateParams } from '../store/types';

export const useCreateWhitelist = () => {
  const [createWhitelist, { isLoading, isSuccess, error }] = useCreateWhitelistMutation();
  const createError = handleWhitelistCreateError(error);

  useShowResponseStatus({
    isSuccess,
    successMessage: 'Запись успешно добавлена',
    error: createError,
  });

  const handleCreateWhitelist = async (params: TWhitelistCreateParams) => {
    await createWhitelist(params);
  };

  return {
    handleCreateWhitelist,
    createWhitelist,
    isLoading,
  };
};
